"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detail = void 0;
var joi_1 = __importDefault(require("joi"));
var firstLoan_1 = require("./detail/firstLoan");
var secondLoan_1 = require("./detail/secondLoan");
exports.detail = joi_1.default.object({
    amountCondominiumFee: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('updatedCondominiumFee', {
        is: false,
        then: joi_1.default.number().required(),
        otherwise: joi_1.default.number()
            .strip()
            .allow('')
            .optional(),
    }),
    amountPropertyInsurance: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('updatedPropertyInsurance', {
        is: false,
        then: joi_1.default.number().required(),
        otherwise: joi_1.default.number()
            .strip()
            .allow('')
            .optional(),
    }),
    amountPropertyTax: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('updatedPropertyTax', {
        is: false,
        then: joi_1.default.number().required(),
        otherwise: joi_1.default.number()
            .strip()
            .allow('')
            .optional(),
    }),
    amountUtilities: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('updatedUtilities', {
        is: false,
        then: joi_1.default.number().required(),
        otherwise: joi_1.default.number()
            .strip()
            .allow('')
            .optional(),
    }),
    cmhcLoanAccountNumber: joi_1.default.number()
        .min(1000000)
        .integer()
        .max(99999999)
        .required(),
    currentMarketValue: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    insuredPropertyMunicipalityName: joi_1.default.string()
        .min(0)
        .max(20)
        .required(),
    insuredPropertyPostalCode: joi_1.default.string()
        .min(0)
        .max(6)
        .required(),
    insuredPropertyProvinceCode: joi_1.default.string()
        .min(0)
        .max(2)
        .required(),
    insuredPropertyStreetDirection: joi_1.default.string()
        .min(0)
        .max(2)
        .allow('')
        .optional(),
    insuredPropertyStreetName: joi_1.default.string()
        .min(0)
        .max(30)
        .required(),
    insuredPropertyStreetNumber: joi_1.default.string()
        .min(0)
        .max(7)
        .required(),
    insuredPropertyStreetType: joi_1.default.string()
        .min(0)
        .max(6)
        .required(),
    insuredPropertyUnitNumber: joi_1.default.string()
        .min(0)
        .max(6)
        .allow('')
        .optional(),
    purchasePriceOfHome: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    updatedCondominiumFee: joi_1.default.boolean()
        .allow('')
        .optional(),
    updatedPropertyInsurance: joi_1.default.boolean().required(),
    updatedPropertyTax: joi_1.default.boolean().required(),
    updatedUtilities: joi_1.default.boolean().required(),
    firstLoan: firstLoan_1.firstLoan,
    secondLoan: secondLoan_1.secondLoan,
});
exports.default = { detail: exports.detail };
